import { useCallback } from 'react';
import { CHAT_FONT_SIZE_VIEWS } from './chatFontSizeViews';
import type { ChatFontSize } from './types';
import { useSettings } from './useSettings';

/** Размер, пока пользователь его не выбирал, — основной размер текста интерфейса */
const DEFAULT_CHAT_FONT_SIZE: ChatFontSize = 'normal';

/**
 * Размер шрифта ленты карточки диалога, запомненный за пользователем. Один на расшифровку звонка
 * и переписку текстовой коммуникации во всех разделах: размер подбирают под себя, а не под запись.
 */
export const useChatFontSize = () => {
  const { dialogsPage, setDialogsSettings } = useSettings();

  const chatFontSize = dialogsPage.chatFontSize ?? DEFAULT_CHAT_FONT_SIZE;

  const setChatFontSize = useCallback(
    (size: ChatFontSize) => setDialogsSettings({ chatFontSize: size }),
    [setDialogsSettings],
  );

  return { chatFontSize, setChatFontSize };
};

/**
 * Класс текста ленты карточки диалога по выбранному размеру. Читается один раз лентой и раздаётся
 * её элементам: служебные подписи элемента остаются своего размера.
 */
export const useChatFontSizeClass = (): string => {
  const { chatFontSize } = useChatFontSize();
  return CHAT_FONT_SIZE_VIEWS[chatFontSize].textClassName;
};
